var _path, _rect, _rect2, _rect3, _rect4, _rect5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "151.355px",
    height: "101.014px",
    viewBox: "0 0 151.355 101.014",
    enableBackground: "new 0 0 151.355 101.014",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0,37.525C0,37.525,32.896,0,76.304,0s75.051,37.525,75.051,37.525s-32.896,37.525-76.304,37.525 S0,37.525,0,37.525z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.422,
    y: 82.759,
    fill: "#E5E5E5",
    width: 9.578,
    height: 18.255
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.484,
    y: 77.485,
    transform: "matrix(0.9326 -0.3609 0.3609 0.9326 -23.9626 44.9168)",
    fill: "#E5E5E5",
    width: 9.578,
    height: 18.255
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.273,
    y: 62.475,
    transform: "matrix(0.8111 -0.5849 0.5849 0.8111 -16.1783 93.1148)",
    fill: "#E5E5E5",
    width: 9.578,
    height: 18.255
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.359,
    y: 77.485,
    transform: "matrix(-0.9326 -0.3609 0.3609 -0.9326 50.1951 182.5999)",
    fill: "#E5E5E5",
    width: 9.578,
    height: 18.255
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.571,
    y: 62.475,
    transform: "matrix(-0.8111 -0.5849 0.5849 -0.8111 -15.8763 138.0784)",
    fill: "#E5E5E5",
    width: 9.578,
    height: 18.255
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.88aa63ce24d0e04dca352056130419a6.svg";
export { ForwardRef as ReactComponent };